const CardImage = ({ src, alt }) => {
    return (
        <img src={src} className="card-img-top" alt={alt} />
    );
}

export default CardImage;